function NRNuGetIcon({ height = '24', width = '24' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7244 20.1208C14.886 20.1208 13.3954 18.6301 13.3954 16.7915C13.3954 14.9537 14.886 13.4622 16.7244 13.4622C18.5629 13.4622 20.0534 14.9537 20.0534 16.7915C20.0534 18.6301 18.5629 20.1208 16.7244 20.1208ZM10.0839 12.4901C8.93462 12.4901 8.00334 11.5578 8.00334 10.4092C8.00334 9.25979 8.93462 8.32842 10.0839 8.32842C11.2333 8.32842 12.1646 9.25979 12.1646 10.4092C12.1646 11.5578 11.2333 12.4901 10.0839 12.4901ZM16.8717 5.99457H11.3157C8.48437 5.99457 6.18738 8.29179 6.18738 11.1242V16.68C6.18738 19.5132 8.48437 21.8088 11.3157 21.8088H16.8717C19.7047 21.8088 22 19.5132 22 16.68V11.1242C22 8.29179 19.7047 5.99457 16.8717 5.99457Z"
        fill="#004880"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.32898 4.04277C5.32898 4.96249 4.58329 5.70743 3.66449 5.70743C2.74486 5.70743 2 4.96249 2 4.04277C2 3.12388 2.74486 2.37811 3.66449 2.37811C4.58329 2.37811 5.32898 3.12388 5.32898 4.04277Z"
        fill="#004880"
      />
    </svg>
  );
}
export default NRNuGetIcon;
